const type = 'CLOSE_CANCEL_INVOICE_INSTALLMENT';

const closeCancelInvoiceInstallment = () => ({
  type,
});

export { type };
export default closeCancelInvoiceInstallment;
